import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class IntegracoesHttpService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(
    private tokenService: TokenService,
    private http: HttpClient
  ) { }

  getIntegracaoBomControle(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/configuracoes/integracao/bomcontrole`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  listarIntegracoesIA(params): Observable<any> {
    this.httpOptions.params = params;
    return this.http.get(`${this.apiUrl}api/ia-integracao/empresa/${this.tokenService.getUsuario().empresa_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  buscarProvedoresIA(params?): Observable<any> {
    this.httpOptions.params = params ? params : null;
    return this.http.get(`${this.apiUrl}api/ia-integracao/provedores`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  criarIntegracaoIA(dados): Observable<any> {
    dados.empresa_id = this.tokenService.getUsuario().empresa_id;
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/ia-integracao`, dados, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizaIntegracaoIA(dados, integracao_id): Observable<any> {
    this.httpOptions.params = null;
    return this.http.put(`${this.apiUrl}api/ia-integracao/${integracao_id}`, dados, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  obtemConfiguracaoGeralEmpresa(): Observable<any> {
    this.httpOptions.params = null;
    return this.http.get(`${this.apiUrl}api/ia-configuracao/empresa/${this.tokenService.getUsuario().empresa_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizaConfiguracaoGeralEmpresa(config): Observable<any> {
    this.httpOptions.params = null;
    return this.http.put(`${this.apiUrl}api/ia-configuracao/empresa/${this.tokenService.getUsuario().empresa_id}`, config, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  validaTokenIntegracao(payload): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/ia-integracao/validar-token`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
